module.exports = __webpack_public_path__ + "img/banner.1e7dc0f6.png";